import useSWR from "swr";

import { SortQueryDirection, usePaginationControls } from "@ds-cps/ui";

import { auditLogEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

import {
  AuditLogModelKeys,
  FilterOptionsByForAuditLog,
  PagedAuditLogResponse
} from "../models";
import { CreateParamsForAuditLog } from "./CreateParamsForAuditLog";

export function useGetAuditLog(
  activeSort: string,
  sortDirection: SortQueryDirection,
  filterOptions?: FilterOptionsByForAuditLog
) {
  const { pageIndex, pageSize } = usePaginationControls();

  const params = new CreateParamsForAuditLog();
  params.withPagination(pageSize, pageIndex);
  params.withSortBy(activeSort as AuditLogModelKeys);
  params.withSortDirection(sortDirection);
  params.withFilterOptions(filterOptions);

  const url = auditLogEndpoints.getAuditLog + `?${params.toString()}`;

  const fetcherWithToken = (url: string) => fetcher<PagedAuditLogResponse>(url);

  const { data, error, isLoading, mutate } = useSWR(url, fetcherWithToken, {
    revalidateOnFocus: false
  });

  return {
    auditLog: data?.auditLog,
    totalCount: data?.total,
    isLoading,
    hasError: Boolean(error),
    mutate
  };
}
